<template>
  <v-dialog
    v-model="show"
    scrollable
    max-width="600px"
    width="90vw"
  >
    <v-card
      min-height="90vh"
    >
      <v-card-title>
        <v-text-field
          dense
          label="Search"
          v-model="search"
          append-icon="mdi-magnify"
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-checkbox
          v-model="groupByProjectGroup"
          label="Group By Project Group"
          dense
          hide-details
        ></v-checkbox>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-subtitle class="d-flex">
        <v-checkbox
          dense
          hide-details
          label="Select All"
          v-model="selectAll"
          :indeterminate="isSomeFilteredProjectsSelected"
          @change="toggleAllProjects"
        ></v-checkbox>
        <v-spacer></v-spacer>
        <v-checkbox
          dense
          hide-details
          label="Show Released"
          v-model="showReleased"
        ></v-checkbox>
        <v-spacer></v-spacer>
        <v-checkbox
          dense
          hide-details
          label="Show Selected"
          v-model="showSelected"
        ></v-checkbox>
        <v-spacer></v-spacer>
        <v-checkbox
          dense
          hide-details
          label="Show Deleted"
          v-model="showDeleted"
        ></v-checkbox>
      </v-card-subtitle>
      <v-divider></v-divider>
      <v-card-text class="py-3">
        <v-data-table
          dense
          :search="search"
          :items="filteredProjects"
          :headers="headers"
          :item-class="getItemClass"
          item-key="Project_ID"
          :group-by="groupByProjectGroup ? 'Project_Group' : null"
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:[`item.Is_Selected`]="{ item }">
            <v-checkbox
              class="ma-0 pa-0"
              hide-details
              dense
              v-model="item.Is_Selected"
              @change="updateSelectedProjectsList"
            ></v-checkbox>
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          small
          outlined
          color="primary"
          @click="show = false"
        >
          cancel
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          small
          color="primary"
          @click="updateListOfProjects"
        >
          save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'ProjectsListSettingsDialog',
  props: {
    value: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      search: '',
      selectedProjects: [],
      headers: [
        {
          text: '',
          class: 'pb-1',
          sortable: false,
          value: 'Is_Selected'
        },
        {
          class: 'text-no-wrap',
          text: 'Project Name',
          value: 'Description'
        },
        {
          text: 'Project Group',
          value: 'Project_Group',
          class: 'text-no-wrap'
        }
      ],
      projects: [],
      showDeleted: false,
      showSelected: false,
      showReleased: false,
      selectAll: false,
      groupByProjectGroup: false
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    show: {
      get () {
        if (this.value) {
          this.getListOfProjects()
        }
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    filteredProjects () {
      let proj = this.projects.filter(p => !p.Is_Deleted)
      if (this.showDeleted) {
        proj = this.projects
      }
      if (!this.showReleased) {
        proj = proj.filter(p => p.Status !== 'R')
      }
      if (this.showSelected) {
        proj = proj.filter(p => p.Is_Selected)
      }
      if (this.search) {
        proj = proj.filter(p => p.Description.toLowerCase().includes(this.search.toLowerCase()))
      }
      return proj
    },
    isAllFilteredProjectsSelected () {
      return this.filteredProjects.length > 0 && this.filteredProjects.length === this.filteredProjects.filter(p => p.Is_Selected).length
    },
    isSomeFilteredProjectsSelected () {
      const totalSelected = this.filteredProjects.filter(p => p.Is_Selected).length
      return totalSelected > 0 && totalSelected < this.filteredProjects.length
    }
  },
  methods: {
    updateSelectedProjectsList () {
      this.selectedProjects = this.projects.filter(p => p.Is_Selected).map(p => p.Project_ID)
      if (this.selectedProjects.length === this.projects.length) {
        this.selectAll = true
      }
    },
    getItemClass (item) {
      if (item.Is_Deleted) {
        return 'yellow lighten-5'
      }
      if (item.Status === 'R') {
        return 'blue lighten-5'
      }
      return ''
    },
    getListOfProjects () {
      this.axios.get('/api/projects-list-cmp', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.projects = res.data
        this.updateSelectedProjectsList()
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    updateListOfProjects () {
      this.axios.post('/api/projects-list-cmp', {
        Projects: this.selectedProjects.join(', ')
      }, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setSuccess', { successMsg: 'Projects list successfully updated' })
        this.show = false
        this.$emit('updateProjectsList')
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    toggleAllProjects () {
      this.filteredProjects.forEach(p => {
        p.Is_Selected = this.selectAll
      })
      this.updateSelectedProjectsList()
    }
  },
  watch: {
    isAllFilteredProjectsSelected (newVal) {
      if (newVal !== this.selectAll) {
        this.selectAll = newVal
      }
    }
  }
}
</script>
